import { render, staticRenderFns } from "./overseeDetail.vue?vue&type=template&id=a20a159c&scoped=true"
import script from "./overseeDetail.vue?vue&type=script&lang=js"
export * from "./overseeDetail.vue?vue&type=script&lang=js"
import style0 from "./overseeDetail.vue?vue&type=style&index=0&id=a20a159c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20a159c",
  null
  
)

export default component.exports